import { PrizmLanguageCron } from '../../interfaces';

export const PRIZM_RUSSIAN_CRON: PrizmLanguageCron = {
  cron: {
    title: 'Cron',
    submitText: 'Применить',
    resetText: 'Отменить',
    startDateLabel: 'Начало работы',
    endDateLabel: 'Конец работы',
    indefinitelyLabel: 'Бессрочно',
    day: {
      every: 'Каждый день',
    },
  },
};
